import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 完成按钮 */
const CompleteButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

CompleteButton.defaultProps = {
  icon: ICON_COLLECTION.ADOPT,
  text: '完成',
};

export default CompleteButton;
